import React, { memo } from 'react';
import { View } from 'react-native';
import { useTheme } from '@redlink/assets/styles';

export const WebScrollView = memo(({ children }) => {
  const { size } = useTheme();
  return (
    <View style={{ flex: 1 }}>
      <div
        style={{
          overflow: 'scroll',
          'padding-left': size.pagePadding,
          'padding-right': size.pagePadding,
          'padding-top': size.verticalPagePadding,
          'padding-bottom': size.verticalPagePadding,
        }}
      >
        {children}
      </div>
    </View>
  );
});
